import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";

export const CtaBand = ({ title, button }) => (
  <section className="wrap py-16 sm:py-24">
    <Reveal className="grain relative overflow-hidden rounded-[28px] bg-[#EFEAF6] px-6 py-16 sm:px-14 sm:py-20">
      <img src="/botanical-texture.webp" alt="" aria-hidden="true" loading="lazy" className="absolute inset-0 h-full w-full object-cover opacity-40 mix-blend-multiply" />
      <div className="relative max-w-xl">
        <h2 className="text-3xl leading-tight text-[#22304A] sm:text-4xl lg:text-5xl" data-testid="final-cta-title">{title}</h2>
        <Link to="/book" className="btn-primary mt-8" data-testid="final-cta-button">
          {button} <ArrowRight className="h-4 w-4" aria-hidden="true" />
        </Link>
      </div>
    </Reveal>
  </section>
);
